module.exports = __webpack_public_path__ + "static/media/booster_4_left.6224abe1.png";